export default __webpack_public_path__ + "static/media/cadence_logo (1).ec90f94c.svg";